import styled from 'styled-components';

import { PlanAGAD } from 'features/Subscribe/components/PlanAGAD';

export const StyledPlanAGAD = styled(PlanAGAD)`
    &:not(:last-child) {
        margin-bottom: 1.5rem;
    }
`;

export const StyledFooter = styled.div`
    position: fixed;
    bottom: 0;
    right: 0;
    left: 0;
    text-align: right;
    background: lightgreen;
    border-top: 1px solid #ccc;
    padding: 1rem 3rem;
    display: flex;
    align-items: center;

    button {
        float: right;
        min-width: 100px;
        font-size: 0.9em;
    }
`;

export const StyledFooterTextContainer = styled.div`
    flex: 1.5;
    text-align: left;
    font-size: 0.9em;
`;

export const StyledButtonContainer = styled.div`
    flex: 1;
`;
